import { render } from "./enterStockDetails.vue?vue&type=template&id=386d507c&scoped=true"
import script from "./enterStockDetails.vue?vue&type=script&lang=js"
export * from "./enterStockDetails.vue?vue&type=script&lang=js"

import "./enterStockDetails.vue?vue&type=style&index=0&id=386d507c&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386d507c"]])

export default __exports__